export class Environnement {
    applicationName: string;
    apiUrl: string;
}
